import { cx } from "@emotion/css";
import { forwardRef, ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createLinkStyles } from "../helpers/createLinkStyles";

interface ExternalLinkProps {
  to: string;
  targetBlank?: boolean;
  className?: string;
  disabled?: boolean;
  children?: ReactNode;
  title?: string;
  download?: string;
  onClick?: () => void;
}

export const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  (
    {
      to,
      targetBlank = true,
      className,
      disabled,
      children,
      title,
      download,
      onClick,
    },
    ref
  ) => {
    const classes = createLinkStyles(useTheme());

    if (disabled) {
      return (
        <span className={cx(className, classes.disabled)}>{children}</span>
      );
    }
    return (
      <a
        className={cx(className, classes.root)}
        href={to}
        rel="noreferrer noopener"
        target={targetBlank ? "_blank" : undefined}
        title={title}
        download={download}
        ref={ref}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }
);
